import "./App.css";
import Header from "./components/Header";
import Rate from "./pages/Rate";
import Home from "./pages/Home";

function App() {
  return (
    <div className="App">
     <Home />
    </div>
  );
}

export default App;
